import { Environment } from '@thiememeulenhoff/types';
import { environment } from '../environments/environment';

/**
 * Whether the app is running in the local development environment. Used to
 * disable Sentry locally so dev builds never send events to the dashboard.
 */
export const isLocalEnvironment = (): boolean => {
  return environment.environment === Environment.Development;
};
